import Joi from 'joi';
import { TEventTypes } from '../../generated/graphql';
import { AWSDateSchema } from '../shared/utils';
import { BRICK_COLOR_OPTIONS_BY_SIZE, BRICK_SIZE_CONFIG, normalizeBrickText, ONE_OFF_EVENT_TYPES, TBrickSize } from './oneOff';
import { clearableField } from '../shared/clearableField';

export const getOneOffEventSchema = (employeeIds: string[], eventTypes: TEventTypes[] = ONE_OFF_EVENT_TYPES) => {
  return Joi.object()
    .unknown(false)
    .keys({
      companyId: Joi.forbidden(),
      employeeIds: Joi.array()
        .items(
          Joi.string()
            .trim()
            .valid(...employeeIds)
        )
        .min(1)
        .required(),
      type: Joi.string()
        .valid(...eventTypes)
        .required(),
      customType: clearableField(Joi.string().trim()),
      eventDate: AWSDateSchema.required(),
      notes: Joi.string().trim().empty(Joi.valid('', null)).default(null).allow(null),
      brickQuantity: Joi.when('employeeIds', {
        is: Joi.array().length(1),
        then: Joi.number().integer().min(1).max(2147483647).required(),
        otherwise: Joi.any().strip()
      }),
      brickSize: Joi.string()
        .valid(...Object.keys(BRICK_SIZE_CONFIG))
        .required(),
      brickColor: Joi.string()
        .trim()
        .required()
        .custom((value, helpers) => {
          const brickSize = helpers.state.ancestors[0]?.brickSize as TBrickSize | undefined;
          const availableColors: readonly string[] = brickSize ? BRICK_COLOR_OPTIONS_BY_SIZE[brickSize] : [];

          if (!availableColors.includes(value)) return helpers.error('any.only');

          return value;
        })
        .messages({
          'any.only': 'The selected brick color is not available for this brick size.'
        }),
      brickText: Joi.string()
        .trim()
        .min(1)
        .custom((value) => normalizeBrickText(value))
        .required()
    });
};
